"use client";
import CheckboxField from "@/components/common/formElements/controlled/CheckboxField";
import CustomOptionHeading from "@/components/site-builder/modules/CustomFormModule/components/FormFieldMapper/CustomOptionHeading";
import type { ProcessedOption } from "@/components/site-builder/modules/CustomFormModule/types";

export function renderCheckboxOptions(
  fieldName: string,
  options: ProcessedOption[],
) {
  return options.map((option) => {
    if (!option.isShown) return null;

    if (option.isHeading) {
      return (
        <CustomOptionHeading key={`heading-${option.value}`} option={option} />
      );
    }

    return (
      <CheckboxField
        key={`${fieldName}.${option.value}`}
        name={fieldName}
        multiple
        label={option.label}
        value={option.value}
        errorMessageDisabled
        fullWidth={false}
        sx={{ ml: option.level * 2 }}
      />
    );
  });
}
